import React from 'react';
import { useContext } from 'react';
import { SyncLoader } from 'react-spinners';
import { GlobalContext } from '../context/GlobalContext';

function Loader() {
    const { state } = useContext(GlobalContext);
    const { loading } = state;

    return (
        <>
            {loading === true && (
                <div className='fixed z-20 flex h-screen w-full items-center justify-center bg-slate-100'>
                    <SyncLoader color='#0ea5e9' />
                </div>
            )}
        </>
    );
}

export default Loader;
